import { Tag } from "@/graphql/generated/graphql";

export const hasVirtualAgentCallTag = (tags: Tag[]) =>
  tags.some((tag) => tag.description === "voice_virtual_agent");
